import React, { useState, useEffect, useRef } from "react";
import RICIBs from "react-individual-character-input-boxes";
import CopyIcon from "../assets/copy.png";
import CheckMark from "../assets/check-mark.png";
import Cross from "../assets/baddoc.png";
import Processing from "../assets/processing.png";
import image1 from "../assets/image1.png";
import Header from "./Header";
import Footer from "./Footer";
import { useContext } from "react";
import { Context } from "../context";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Support from "./Support";
import { env as environment } from "../controllers/environment";
import { Oval, RotatingLines, Hourglass } from "react-loader-spinner";
import axios from "axios";
import copy from 'copy-to-clipboard';
import { Tooltip } from 'react-tooltip';
// import io from 'socket.io-client';
import ls from "localstorage-slim";
import Modal from 'react-bootstrap/Modal';
import ReactPlayer from 'react-player'


ls.config.encrypt = true;
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
	},
};

const Buttons = () => {
	const [vidUrl, setVidUrl] = useState("");
	const [modalShow, setModalShow] = React.useState(false);
	const navigate = useNavigate();
	const {
		data,
		setData,
		inputEmail,
		setInputEmail,
		setButtonSelection,
		buttonStatus,
		setButtonStatus,
		setExtraBankButton,
		setButtonIndex,
		setResubmit,
		fullscreen,
		supportPage,
		setSupportPage,
	} = useContext(Context);

	const { trackid } = useParams();

	// console.log("PARAMS", trackid);
	// const [submissionId, setSubmissionId] = useState();
	const [copyAlert, setCopyAlert] = useState();
	const [showSubmissionId, setShowSubmissionId] = useState([false, false, false, false, false]);
	const [utilityResubmitWarning, setUtilityResubmitWarning] = useState(false);
	const [bankResubmitWarning, setBankResubmitWarning] = useState(false);
	// const [documentsProcessed, setDocumentsProcessed] = useState();
	const [loader, setLoader] = useState(false);
	const [spinner2, setSpinner2] = useState(false);

	const [extraButton, setExtraButton] = useState(false);
	console.log("inputEmail:Buttons", inputEmail);

	// === Scroll to new added button ===
	let ref1 = useRef();
	function scrollTo(ref) {
		console.log("rrrrrrr", ref);
		if (ref.current) {
			console.log("refffffffff");
			ref.current.scrollIntoView({ behavior: "smooth" });
		}
	}
	// === Copy submission ID ===
	const copyId = (id, index) => {
		if (id) {
			// navigator.clipboard.writeText(id);
			copy(id)
			setCopyAlert(index);
			setTimeout(() => {
				setCopyAlert();
			}, [5000]);
		}
	};
	const handleSupport = () => {
		setSupportPage(true);
	};

	const openResubmitPopup = async (buttonType) => {
		if (buttonType === "utility") {

			setUtilityResubmitWarning(true)
		}
		if (buttonType === "bank") {
			setBankResubmitWarning(true)
		}

	}
	const closeResubmitPopup = async (buttonType) => {
		if (buttonType === "utility") {

			setUtilityResubmitWarning(false)
		}
		if (buttonType === "bank") {
			setBankResubmitWarning(false)
		}
	}

	//=== Bank verification ===
	const bankVerification = (id) => {

		const storedEmail = ls.get('inputEmail');
		if (trackid === storedEmail) {
			setButtonSelection("bank_verify");
			setResubmit(false);
			navigate("/verification");
			setExtraBankButton(false);
			setButtonIndex(id);
		}
		else {
			navigate("/")
		}

	};
	//===  Resubmit Bank verification ====
	const bankVerificationResubmit = (id) => {

		const storedEmail = ls.get('inputEmail');
		if (trackid === storedEmail) {
			setButtonSelection("bank_verify");
			setResubmit(true);
			setButtonIndex(id);
			setExtraBankButton(false);
			navigate("/verification");
			console.log("Resubmit::incId", id);
		}
		else {
			navigate("/")
		}
	};

	//==== Bank verification for the extra bank button ===
	const bankVerification2 = () => {

		const storedEmail = ls.get('inputEmail');
		if (trackid === storedEmail) {
			setButtonSelection("bank_verify");
			setResubmit(false);
			setExtraBankButton(true);
			navigate("/verification");
		}
		else {
			navigate("/")
		}

	};

	//=== Utility verification ===
	const utilityVerification = (id) => {
		const storedEmail = ls.get('inputEmail');
		if (trackid === storedEmail) {
			setButtonSelection("utility_verify");
			setResubmit(false);
			navigate("/verification");
			setButtonIndex(id);
		}
		else {
			navigate("/")
		}
	};
	// === Resubmit Utility ===
	const utilityVerificationResubmit = (id) => {
		const storedEmail = ls.get('inputEmail');
		if (trackid === storedEmail) {
			setButtonSelection("utility_verify");
			setResubmit(true);
			navigate("/verification");
			setButtonIndex(id);
		}
		else {
			navigate("/")
		}

	};

	//=== Add bank button ===
	const handleAddBank = () => {
		setExtraButton(true);
		// myRef.current?.scrollIntoView();
		// scrollToBottom();
		setTimeout(() => {
			scrollTo(ref1);
		}, 100);
	};

	//=== Get email from url and get the button status ===
	const startExisting = async () => {
		const json = { email: trackid, apikey: environment.apikey };
		await axios.post(environment.verifycontinue, json).then((res) => {
			console.log("handleContinue::RES::", res?.data);
			setData(res?.data);
			setInputEmail(trackid);
			ls.set("inputEmail", trackid);
			setButtonStatus(res?.data?.data);
			ls.set("buttonstatus", JSON.stringify(res?.data?.data));
			console.log("data::afterContinue", data);
			setLoader(false);
			if (res?.data?.email_exists) {
				navigate("/buttons/" + trackid);
			} else {
				navigate("/");
			}
			//===== Check if both Bank and Utility were submitted and their json is processed =====
			for (let i = 0; i < res.data.data?.length; i++) {
				if (res?.data?.data[i]?.status?.bank_verify === "completed" && res?.data?.data[i]?.status?.bank_verify_callback === true && res?.data?.data[i]?.status?.bank_bad_doc === false &&
					res?.data?.data[i]?.status?.utility_verify === "completed" && res?.data?.data[i]?.status?.utility_verify_callback === true && res?.data?.data[i]?.status?.utility_bad_doc === false) {
					const updatedArray = [...showSubmissionId];
					for (let j = 0; j <= i; j++) {
						updatedArray[j] = true;
					}
					setShowSubmissionId(updatedArray)
				}

			}

		});
	};

	useEffect(() => {
		var interval;
		//=== If email/trackid is found in url start an existing session ===

		startExisting();
		// interval = setInterval(() => {
		// 	startExisting();
		// }, 20000);
		setLoader(true);


		setInputEmail(ls.get("inputEmail"));
		//=== Disable browser's back button ===
		window.addEventListener("popstate", (e) => {
			window.history.go(1);
		});
		if (!buttonStatus) {
			//=== Set buttondata from localstorage on refresh ===
			const data = JSON.parse(ls.get("buttonstatus"));
			setButtonStatus(data);
			// setInputEmail();
		}

		console.log("Buttons::btnstatus", buttonStatus);
		// if (!inputEmail) navigate("/");
		// if (extraButton) scrollToBottom();
		return () => {
			clearInterval(interval);
		};
	}, [setButtonSelection]); //eslint-disable-line

	const handleOutput = (string) => {
		console.log("string", string);
	};

	const handleFresh = async (e) => {
		e.preventDefault();
		setSpinner2(true);
		const json = { email: inputEmail, apikey: environment.apikey };
		await axios.post(environment.startfresh, json).then((res) => {
			console.log("startFresh", res.data);
			// setData(res.data);
			setButtonStatus(res?.data?.data);
			ls.set("buttonstatus", JSON.stringify(res?.data?.data));
			setExtraButton(false);
			// setTimeout(() => {
			// 	navigate("/buttons/" + inputEmail);
			// }, 1000);
		});
	};


	const videoModal = (type) => {
		if (type === "address") { setVidUrl("https://diro.wistia.com/medias/jch091mayp") }

		else if (type === "bank") { setVidUrl("https://diro.wistia.com/medias/cx1ky37o0s") }
		else {
			setVidUrl("https://diro.wistia.com/medias/v8cio55het")
		}
		setModalShow(true)
	}

	function MyVerticallyCenteredModal(props) {
		return (
			<Modal
				{...props}
				size="lg"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-vcenter">
						{
							vidUrl === "https://diro.wistia.com/medias/jch091mayp" && <h5>Address verification tutorial</h5>
						}
						{
							vidUrl === "https://diro.wistia.com/medias/cx1ky37o0s" && <h5>Bank verification tutorial</h5>
						}
						{
							vidUrl === "https://diro.wistia.com/medias/v8cio55het" && <h5>Verification code tutorial</h5>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* <video src={AddressVideo}></video> */}
					<ReactPlayer controls={true} width={"100%"} url={vidUrl} />
				</Modal.Body>
				{/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
			</Modal>
		);
	}


	// if(buttonStatus?.item?.status?.bank_verify === "completed"  && item?.status?.bank_verify_callback ===true && item?.status?.bank_bad_doc === false && 
	// 						item?.status?.utility_verify === "completed"  && item?.status?.utility_verify_callback ===true && item?.status?.utility_bad_doc === false){
	// 							setShowSubmissionId(true)
	// 						}

	return (
		<>
			<Tooltip id="my-tooltip" className="tooltip" place="top" />
			{supportPage && <Support />}
			<div className="parent buttons_page">
				{/* <Header redirect={true} /> */}
				<div className="sidebar_container_wrapper">
					<Sidebar noicons={true} setHeadingHght={0} />
					{!buttonStatus && (
						<Oval
							height={45}
							width={45}
							color="#4fa94d"
							wrapperStyle={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
							wrapperClass=""
							visible={true}
							ariaLabel="oval-loading"
							secondaryColor="#4fa94d"
							strokeWidth={5}
							strokeWidthSecondary={5}
						/>
					)}

					<div className="submission_id_wrap">
						{buttonStatus?.map((item, index) => {
							console.log("mappp", item, index);
							console.log("showSubmissionID", showSubmissionId)
							if (index === 0) {
								return (
									<>
										{
											utilityResubmitWarning &&
											<div className="bg-blur-modal">
												<div className="modal-container">
													<p>
														Previously submitted data and the verification code will be lost.<br></br> Are you sure you want to resubmit?
													</p>
													<div className="resubmit-btns-container">
														<button className="resubmit-btn-2" onClick={() => utilityVerificationResubmit(item?.incId)}>
															Yes, continue
														</button>
														<button className="resubmit-btn-2" onClick={() => closeResubmitPopup("utility")}>
															No
														</button>

													</div>
												</div>
											</div>
										}
										{
											bankResubmitWarning &&
											<div className="bg-blur-modal">
												<div className="modal-container">
													<p>
														Previously submitted data and the verification code will be lost.<br></br> Are you sure you want to resubmit?
													</p>
													<div className="resubmit-btns-container">

														<button className="resubmit-btn-2" onClick={() => bankVerificationResubmit(item?.incId)}>
															Yes, continue
														</button>
														<button className="resubmit-btn-2" onClick={() => closeResubmitPopup("bank")}>
															No
														</button>
													</div>
												</div>
											</div>
										}
										{item?.status?.bank_verify === "completed" || item?.status?.utility_verify === "completed" ? (
											""
										) : (
											<div className="start_clicking_quote">Click the green button to start the verification process. Ensure that your bank and address information entered in Coupa matches your utility bill and bank account.</div>
										)}
										<div className="main-container2" key={index}>
											<div className="verification-btn-container">
												{/*==== Utility button =====*/}
												<div className="list-btn">
													{/* {
														item?.status?.utility_verify === "completed" && item?.status?.utility_verify_callback === false && !item?.status?.utility_bad_doc &&
														<p className="processing-text">Processing</p>
													} */}
													{/* {
														item?.status?.utility_verify === "completed" && item?.status?.utility_verify_callback === true && item?.status?.utility_bad_doc === true &&
														<div className="baddoc-text">Resubmit from verified source</div>
													} */}
													<button
														disabled={item?.status?.utility_verify === "completed"}
														className={item?.status?.utility_verify === "completed" ? "verification-btn-disabled" : "verification-btn"}
														onClick={() => utilityVerification(item?.incId)}
													>
														Address verification
														<br />
														<span className="processing-text">
															{/* {buttonStatus?.utility_verify === "completed" && inputEmail === data?.data?.email && !buttonStatus?.utility_verify_callback
												? "Processing..."
												: ""} */}
														</span>
													</button>

													{(item?.status?.utility_verify === "completed" && item?.status?.utility_verify_callback === true && !buttonStatus[1]) ? (
														<button className="resubmit-btn" onClick={() => item?.unique_submissionID !== "" ? openResubmitPopup("utility") : utilityVerificationResubmit(item?.incId)}>
															Resubmit
														</button>
													) : (
														""
													)}
													{item?.status?.utility_verify === "completed" && item?.status?.utility_verify_callback === false && <img className="check-mark" src={CheckMark} alt="check mark" data-tooltip-id="my-tooltip" data-tooltip-content="Document submitted." />}
													{item?.status?.utility_verify === "completed" && item?.status?.utility_verify_callback === true && item?.status?.utility_bad_doc === true && <img className="baddoc-cross" src={Cross} alt="bad document" data-tooltip-id="my-tooltip" data-tooltip-content="This document was rejected, please resubmit from verified source." />}
													{item?.status?.utility_verify === "completed" && item?.status?.utility_verify_callback === true && item?.status?.utility_bad_doc === false && <img className="baddoc-cross" src={CheckMark} alt="bad document" data-tooltip-id="my-tooltip" data-tooltip-content="Document processed successfully." />}
													{/* {item?.status?.utility_verify === "completed" && item?.status?.utility_verify_callback === false && !item?.status?.utility_bad_doc &&
														<div data-tooltip-id="my-tooltip" data-tooltip-content="Under processing, this might take upto 24 hrs on weekdays.">
															<Hourglass
																visible={true}
																height="23"
																width="23"
																ariaLabel="hourglass-loading"
																wrapperStyle={{}}
																wrapperClass=""
																colors={['#40be90', '#15a771']}
															/>
														</div>
													} */}

													{/* {buttonStatus?.utility_verify_callback ? <img src={CheckMark} alt="check mark" /> : ""} */}
												</div>

												{/*==== Bank button =====*/}
												{/* <Tooltip id="my-tooltip" className="tooltip" /> */}
												<div className="list-btn">
													{/* {
														item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === false && !item?.status?.bank_bad_doc &&
														<p className="processing-text">Processing</p>
													} */}
													{/* {
														item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === true && item?.status?.bank_bad_doc === true &&
														<p className="baddoc-text">Resubmit from verified source</p>
													} */}
													<button
														disabled={item?.status?.bank_verify === "completed"}
														className={item?.status?.bank_verify === "completed" ? "verification-btn-disabled" : "verification-btn"}
														onClick={() => bankVerification(item?.incId)}
													>
														Bank account verification
														<br />
														<span className="processing-text">
															{/* {buttonStatus?.bank_verify === "completed" && inputEmail === data?.data?.email && !buttonStatus?.bank_verify_callback
												? "Processing..."
												: ""} */}
														</span>
													</button>
													{item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === true ? (
														<button className="resubmit-btn" onClick={() => item?.unique_submissionID !== "" ? openResubmitPopup("bank") : bankVerificationResubmit(item?.incId)}>
															Resubmit
														</button>
													) : (
														""
													)}

													{item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === false && <img className="check-mark" src={CheckMark} alt="check mark" data-tooltip-id="my-tooltip" data-tooltip-content="Document submitted." />}
													{item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === true && item?.status?.bank_bad_doc === true && <img className="baddoc-cross" src={Cross} alt="check mark" data-tooltip-id="my-tooltip" data-tooltip-content="This document was rejected, please resubmit from verified source." />}
													{item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === true && item?.status?.bank_bad_doc === false && <img className="baddoc-cross" src={CheckMark} alt="check mark" data-tooltip-id="my-tooltip" data-tooltip-content="Document processed successfully." />}
													{/* {item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === false &&
														<div data-tooltip-id="my-tooltip" data-tooltip-content="Under processing, this might take upto 24 hrs on weekdays.">

															<Hourglass
																visible={true}
																height="23"
																width="23"
																ariaLabel="hourglass-loading"
																wrapperStyle={{}}
																wrapperClass=""
																colors={['#40be90', '#15a771']}
															/>
														</div>
													} */}
												</div>
											</div>
											<div>
												<img className="combine-img" src={image1} alt="" />
											</div>
											<div className="submission-id-container">
												{/* <h2>Your submission ID:</h2> */}
												<div className="submission-id-content">
													<div className="id-bg ">


														{
															// (item?.status?.bank_verify === "completed" && item?.status?.utility_verify === "completed") &&
															// (item?.status?.bank_verify_callback === false || item?.status?.utility_verify_callback === false)) ?
															// <p className="processing-both-docs">Email with your <br></br> verification code will be <br></br> sent after processing</p> :

															<>
																<h5 className="id-bg-text">Verification code</h5>
																<RICIBs
																	amount={6}
																	handleOutputString={handleOutput}
																	inputProps={[
																		{
																			value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[0] : ""}`,
																			className: "2fa-box",
																			style: {
																				border: "none",
																				outline: "none",
																				width: "30px",
																				height: "35px",
																				padding: "5px",
																				fontSize: "22px",
																				pointerEvents: "none",
																			},
																		},
																		{
																			value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[1] : ""}`,
																			className: "2fa-box",
																			style: {
																				border: "none",
																				outline: "none",
																				width: "30px",
																				height: "35px",
																				padding: "5px",
																				fontSize: "22px",
																				pointerEvents: "none",
																			},
																		},
																		{
																			value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[2] : ""}`,
																			className: "",
																			style: {
																				border: "none",
																				outline: "none",
																				width: "30px",
																				height: "35px",
																				padding: "5px",
																				fontSize: "22px",
																				// marginRight: "30px",
																				pointerEvents: "none",
																			},
																		},
																		{
																			value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[3] : ""}`,
																			className: "2fa-box",
																			style: {
																				border: "none",
																				outline: "none",
																				width: "30px",
																				height: "35px",
																				padding: "5px",
																				fontSize: "22px",
																				pointerEvents: "none",
																			},
																		},
																		{
																			value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[4] : ""}`,
																			className: "2fa-box",
																			style: {
																				border: "none",
																				outline: "none",
																				width: "30px",
																				height: "35px",
																				padding: "5px",
																				fontSize: "22px",
																				pointerEvents: "none",
																			},
																		},
																		{
																			value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[5] : ""}`,
																			className: "2fa-box",
																			style: {
																				border: "none",
																				outline: "none",
																				width: "30px",
																				height: "35px",
																				padding: "5px",
																				fontSize: "22px",
																				pointerEvents: "none",
																			},
																		},
																	]}
																	inputRegExp={/^[A-Za-z0-9]*$/}
																	disabled
																/>
															</>
														}
													</div>

													<div className="copy-container" onClick={() => copyId(item?.unique_submissionID, index)}>
														{copyAlert === index ? <span className="copy-success">Copied!</span> : ""}
														<img className="copy-img" src={CopyIcon} alt="copy" />
														<span className="copy_txt">Copy</span>
													</div>

												</div>
												{item?.unique_submissionID && index === buttonStatus.length - 1 ? (
													<p className="submission-text">
														To finalize your submission on the Coupa platform for CBRE, click 'Copy' next to the verification code or refer to the code we've sent to your email.
													</p>
												) : (
													""
												)}
												{
													!item?.unique_submissionID &&
													<div className="submission-text-initial">
														<p >
															To finish your CBRE vendor onboarding at Coupa, you'll need a verification code. This will be provided after you've confirmed your address and bank account details.
														</p>


													</div>


												}
											</div>
										</div>
									</>
								);
							} else
								return (
									<div key={index}>
										<div className="extra_bank main-container2">
											<div className="verification-btn-container">

												<div className="list-btn">
													{/* {
														item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === false && !item?.status?.bank_bad_doc &&
														<p className="processing-text">Processing</p>/
													} */}
													{/* {
														item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === true && item?.status?.bank_bad_doc === true &&
														<p className="baddoc-text">Resubmit from verified source</p>
													} */}
													<button
														disabled={item?.status?.bank_verify === "completed"}
														className={item?.status?.bank_verify === "completed" ? "verification-btn-disabled" : "verification-btn"}
														onClick={() => bankVerification(item?.incId)}
													>
														Bank account verification
														<br />
														<span className="processing-text"></span>
													</button>
													{item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === true ? (
														<button className="resubmit-btn" onClick={() => bankVerificationResubmit(item?.incId)}>
															Resubmit
														</button>
													) : (
														""
													)}

													{item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === false && <img className="check-mark" src={CheckMark} alt="check mark" data-tooltip-id="my-tooltip" data-tooltip-content="Document submitted." />}
													{item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === true && item?.status?.bank_bad_doc === true && <img className="baddoc-cross" src={Cross} alt="check mark" data-tooltip-id="my-tooltip" data-tooltip-content="This document was rejected, please resubmit." />}
													{item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === true && item?.status?.bank_bad_doc === false && <img className="baddoc-cross" src={CheckMark} alt="check mark" data-tooltip-id="my-tooltip" data-tooltip-content="Document processed successfully." />}
													{/* {item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === false &&
														<div data-tooltip-id="my-tooltip" data-tooltip-content="Under processing, this might take upto 24 hrs on weekdays.">
															<Hourglass
																visible={true}
																height="23"
																width="23"
																ariaLabel="hourglass-loading"
																wrapperStyle={{}}
																wrapperClass=""
																colors={['#40be90', '#15a771']}
															/>
														</div>
													} */}
												</div>
											</div>
											<div className="add-space">{/* <img className="combine-img" src={image1} alt="" /> */}</div>
											{/* <div>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</div> */}
											<div className="submission-id-container">
												{/* <h2>Your submission ID:</h2> */}
												<div className="submission-id-content">
													<div className="id-bg2 ">
														{/* <h4 className="id-bg-text">Verification code</h4> */}
														<RICIBs
															amount={6}
															handleOutputString={handleOutput}
															inputProps={[
																{
																	value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[0] : ""}`,
																	className: "2fa-box",
																	style: {
																		border: "none",
																		outline: "none",
																		width: "30px",
																		height: "35px",
																		padding: "5px",
																		fontSize: "22px",
																		pointerEvents: "none",
																	},
																},
																{
																	value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[1] : ""}`,
																	className: "2fa-box",
																	style: {
																		border: "none",
																		outline: "none",
																		width: "30px",
																		height: "35px",
																		padding: "5px",
																		fontSize: "22px",
																		pointerEvents: "none",
																	},
																},
																{
																	value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[2] : ""}`,
																	className: "",
																	style: {
																		border: "none",
																		outline: "none",
																		width: "30px",
																		height: "35px",
																		padding: "5px",
																		fontSize: "22px",
																		// marginRight: "30px",
																		pointerEvents: "none",
																	},
																},
																{
																	value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[3] : ""}`,
																	className: "2fa-box",
																	style: {
																		border: "none",
																		outline: "none",
																		width: "30px",
																		height: "35px",
																		padding: "5px",
																		fontSize: "22px",
																		pointerEvents: "none",
																	},
																},
																{
																	value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[4] : ""}`,
																	className: "2fa-box",
																	style: {
																		border: "none",
																		outline: "none",
																		width: "30px",
																		height: "35px",
																		padding: "5px",
																		fontSize: "22px",
																		pointerEvents: "none",
																	},
																},
																{
																	value: `${item?.unique_submissionID ? item?.unique_submissionID?.split("")[5] : ""}`,
																	className: "2fa-box",
																	style: {
																		border: "none",
																		outline: "none",
																		width: "30px",
																		height: "35px",
																		padding: "5px",
																		fontSize: "22px",
																		pointerEvents: "none",
																	},
																},
															]}
															inputRegExp={/^[A-Za-z0-9]*$/}
															disabled
														/>
													</div>
													<div className="copy-container" onClick={() => copyId(item?.unique_submissionID, index)}>
														{copyAlert === index ? <span className="copy-success">Copied!</span> : ""}
														<img className="copy-img" src={CopyIcon} alt="copy" />
														<span className="copy_txt">Copy</span>
													</div>
												</div>
												{item?.unique_submissionID && index === buttonStatus.length - 1 ? (
													<p className="submission-text">
														To finalize your submission on the Coupa platform for CBRE, click 'Copy' next to the verification code or refer to the code we've sent to your email.
													</p>
												) : (
													""
												)}
											</div>
										</div>
									</div>
								);
						})}
						{buttonStatus &&
							buttonStatus[0]?.status?.bank_verify === "completed" &&
							buttonStatus[0]?.status?.utility_verify === "completed" &&
							!extraButton &&
							buttonStatus?.length < 5 ? (
							<div className="add_more_bank main-container2">
								<div style={{ maxWidth: "367px", width: "calc(50% - 32px)", textAlign: "center" }}>
									<button className="add_more_bank_button" onClick={handleAddBank}>
										Add another bank account
									</button>
								</div>
								<div style={{ maxWidth: "360px", width: "calc(50% - 32px)" }}>&nbsp;</div>
							</div>
						) : (
							""
						)}
						{extraButton ? (
							<div ref={ref1} className="extra_bank main-container2 margin-top">
								<div className="verification-btn-container">
									<div className="list-btn">
										{/* {
												item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback === false && !item?.status?.bank_bad_doc &&
												<p className="processing-text">Processing</p>
													}
													{
														item?.status?.bank_verify === "completed" && item?.status?.bank_verify_callback ===true && item?.status?.bank_bad_doc === true && 
														<p className="processing-text">Resubmit</p>
													} */}
										<button className="verification-btn" onClick={bankVerification2}>
											Bank account verification
											<br />
										</button>
									</div>
								</div>
								<div className="add-space2">{/* <img className="combine-img" src={image1} alt="" /> */}</div>
								{/* <div>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</div> */}
								<div className="submission-id-container">
									{/* <h2>Your submission ID:</h2> */}
									<div className="submission-id-content">
										<div className="id-bg2 ">
											{/* <h4 className="id-bg-text">Verification code</h4> */}
											<RICIBs
												amount={6}
												handleOutputString={handleOutput}
												inputProps={[
													{
														value: `${""}`,
														className: "2fa-box",
														style: {
															border: "none",
															outline: "none",
															width: "30px",
															height: "35px",
															padding: "5px",
															fontSize: "22px",
															pointerEvents: "none",
														},
													},
													{
														value: `${""}`,
														className: "2fa-box",
														style: {
															border: "none",
															outline: "none",
															width: "30px",
															height: "35px",
															padding: "5px",
															fontSize: "22px",
															pointerEvents: "none",
														},
													},
													{
														value: `${""}`,
														className: "",
														style: {
															border: "none",
															outline: "none",
															width: "30px",
															height: "35px",
															padding: "5px",
															fontSize: "22px",
															// marginRight: "30px",
															pointerEvents: "none",
														},
													},
													{
														value: `${""}`,
														className: "2fa-box",
														style: {
															border: "none",
															outline: "none",
															width: "30px",
															height: "35px",
															padding: "5px",
															fontSize: "22px",
															pointerEvents: "none",
														},
													},
													{
														value: `${""}`,
														className: "2fa-box",
														style: {
															border: "none",
															outline: "none",
															width: "30px",
															height: "35px",
															padding: "5px",
															fontSize: "22px",
															pointerEvents: "none",
														},
													},
													{
														value: `${""}`,
														className: "2fa-box",
														style: {
															border: "none",
															outline: "none",
															width: "30px",
															height: "35px",
															padding: "5px",
															fontSize: "22px",
															pointerEvents: "none",
														},
													},
												]}
												inputRegExp={/^[A-Za-z0-9]*$/}
												disabled
											/>
										</div>
										<div className="copy-container" onClick={copyId} >
											{/* {copyAlert && <span className="copy-success">Copied!</span>} */}
											<img className="copy-img" src={CopyIcon} alt="copy" />
											<span className="copy_txt">Copy</span>
										</div>
									</div>
									{/* {item?.unique_submissionID ? (
									<p className="submission-text">
										Enter this submission ID in <br /> CBRE's onboarding portal.
									</p>
								) : (
									""
								)} */}
								</div>
							</div>
						) : (
							""
						)}
						<div className="main-container2" style={{ height: "270px" }}>
							<div className="get_supp_btn_wrap" >
								{/* {buttonStatus?.map((item, index) => {
									if (index === 0) {
										return (
											(item?.status?.utility_verify === "completed" || item?.status?.bank_verify === "completed") && (
												<><button style={{ marginLeft: "-1px" }} className="support_button" onClick={handleFresh}>
													{spinner2 ? (
														<RotatingLines strokeColor="rgb(0, 106, 77)" strokeWidth="4" animationDuration="0.75" width="25" visible={true} />
													) : (
														"Start fresh"
													)}
												</button><div style={{ width: "23px", display: "inline-block" }}>&nbsp;</div></>
											)
										);
									}
								})} */}
								<button className="support_button" onClick={handleSupport}>
									Get support
								</button>
								{buttonStatus?.map((item, index) => {
									if (index === 0) {
										return (
											(item?.status?.utility_verify === "completed" || item?.status?.bank_verify === "completed") && (
												<div style={{ width: "23px", display: "inline-block" }}>&nbsp;</div>
											)
										);
									}
								})}
							</div>
							<div style={{ width: "80px" }}>&nbsp;</div>
							<div className="get_supp_btn_space">&nbsp;
								{
									<div className="how-it-works-container">
										<h5 className="how-it-works-text">How it works</h5>
										<MyVerticallyCenteredModal
											show={modalShow}
											onHide={() => setModalShow(false)}
										/>
										<ul className="how-it-works-list">
											<li>
												<span style={{ textDecoration: "underline", textUnderlineOffset: "1px", textDecorationThickness: "1px", cursor: "pointer", color: "#0d6efd" }} onClick={() => videoModal("address")}>
													Address verification
												</span>
												&nbsp;
												(2 min demo)
											</li>
											<li>
												<span style={{ textDecoration: "underline", textUnderlineOffset: "1px", textDecorationThickness: "1px", cursor: "pointer", color: "#0d6efd" }} onClick={() => videoModal("bank")}>
													Bank verification
												</span>
												&nbsp;
												(2 min demo)
											</li>
											<li>
												<span style={{ textDecoration: "underline", textUnderlineOffset: "1px", textDecorationThickness: "1px", cursor: "pointer", color: "#0d6efd" }} onClick={() => videoModal("code")}>
													Verification code
												</span>
												&nbsp;
												(1 min demo)
											</li>
											<li><a style={{ textDecoration: "underline", textUnderlineOffset: "1px", textDecorationThickness: "1px", cursor: "pointer", color: "#0d6efd" }} href="https://mediaassets.cbre.com/-/media/project/cbre/dotcom/global/about/suppliers/supplier-shield/training-guides/how-to-verify-bank-and-address-with-diro.pdf" target="_blank" rel="noreferrer"> Help Guide with FAQ </a> </li>
											<li><a style={{ textDecoration: "underline", textUnderlineOffset: "1px", textDecorationThickness: "1px", cursor: "pointer", color: "#0d6efd" }} href="https://trust.diro.io/" target="_blank" rel="noreferrer"> DIRO Trust Center </a> </li>
										</ul>
									</div>
								}
							</div>

						</div>
					</div>
				</div>
				{/* <button>Get support</button> */}
			</div>
			<Footer />
		</>
	);
};

export default Buttons;
